import { IPromise } from 'angular';

export const StorageProviderFactoryServiceName = 'gpStorageProviderFactory';

export interface StorageFileInfo {
    path: string;
    sizeBytes: number;
    contentType: string;
    lastModified: string;
}

export interface IStorageProvider {
    read(path: string): IPromise<ArrayBuffer>;
    write(path: string, data: ArrayBuffer | Blob, contentType?: string): IPromise<void>;
    list(prefix?: string): IPromise<StorageFileInfo[]>;
    delete(path: string): IPromise<void>;
    exists(path: string): IPromise<boolean>;
}

export interface IStorageProviderFactory {
    getProvider(scopeId: string): IStorageProvider;
}
